import React, { DragEvent } from 'react';

import styles from './WorkflowActions.module.scss';

export const WorkflowActions: React.FC = () => {
    return (
        <div>
            <h3>Workflow Actions</h3>
            <p className='text-sm text-gray-600 mt-sm mb-md'>
                Drag nodes onto the canvas: the <strong>Non Terminal Transition Handler</strong> group holds the primary
                flow; after you add a terminal decision node, <strong>Terminal Transition Handler</strong> holds
                terminal routing (keeps the two flows from overlapping).
            </p>

            <div
                className={styles.sidebarActionItem}
                draggable
                onDragStart={(e: DragEvent) => {
                    e.dataTransfer.setData('application/reactflow', 'callNode');
                    e.dataTransfer.effectAllowed = 'move';
                }}
            >
                Call
            </div>
            <div
                className={styles.sidebarActionItem}
                draggable
                onDragStart={(e: DragEvent) => {
                    e.dataTransfer.setData('application/reactflow', 'smsNode');
                    e.dataTransfer.effectAllowed = 'move';
                }}
            >
                SMS
            </div>
            <div
                className={styles.sidebarActionItem}
                draggable
                onDragStart={(e: DragEvent) => {
                    e.dataTransfer.setData('application/reactflow', 'delayNode');
                    e.dataTransfer.effectAllowed = 'move';
                }}
            >
                Delay
            </div>
            <div
                className={styles.sidebarActionItem}
                draggable
                onDragStart={(e: DragEvent) => {
                    e.dataTransfer.setData('application/reactflow', 'decisionNode');
                    e.dataTransfer.effectAllowed = 'move';
                }}
            >
                Decision
            </div>
            <div
                className={styles.sidebarActionItem}
                draggable
                onDragStart={(e: DragEvent) => {
                    e.dataTransfer.setData('application/reactflow', 'endNode');
                    e.dataTransfer.effectAllowed = 'move';
                }}
            >
                End
            </div>
        </div>
    );
};
